import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { BUSINESS } from "../data/site";
import { SERVICES } from "../data/services";
import { CITIES, COUNTIES } from "../data/cities";
import { CallButton, TextPhotoButton } from "./CTA";

const Footer = () => (
  <footer data-testid="site-footer" className="cut-top bg-coal text-cream mt-[-26px] pt-24 pb-10 relative z-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center w-9 h-9 bg-rust text-cream btn-cut" aria-hidden>
              <Flame size={20} strokeWidth={2.4} />
            </span>
            <span className="font-display font-black uppercase leading-none">Aledo<br /><span className="text-rust">Welding</span></span>
          </div>
          <p className="text-cream/70 text-[15px] leading-relaxed mb-5">
            Repair-first mobile welding serving Fort Worth, Tarrant County, and Parker County since {BUSINESS.established}. We bring the rig to you.
          </p>
          <div className="flex flex-col gap-2.5 items-start">
            <CallButton compact dark testid="footer-call-btn" />
            <TextPhotoButton compact testid="footer-text-btn" />
          </div>
          <p className="mt-4 text-sm text-cream/60">
            <a href={`mailto:${BUSINESS.email}`} data-testid="footer-email" className="hover:text-rust transition-colors">{BUSINESS.email}</a><br />
            {BUSINESS.hours}
          </p>
        </div>
        <nav aria-label="Services">
          <h3 className="font-display font-bold uppercase tracking-wider text-sm text-cream/50 mb-4">Repair Services</h3>
          <ul className="space-y-2.5 text-[15px]">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-cream/80 hover:text-rust transition-colors">{s.name}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Service areas">
          <h3 className="font-display font-bold uppercase tracking-wider text-sm text-cream/50 mb-4">Service Areas</h3>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-[15px]">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/service-areas/${c.slug}`} data-testid={`footer-city-${c.slug}`} className="text-cream/80 hover:text-rust transition-colors">{c.name}</Link>
              </li>
            ))}
            {COUNTIES.map((c) => (
              <li key={c.slug} className="col-span-2">
                <Link to={`/service-areas/${c.slug}`} data-testid={`footer-county-${c.slug}`} className="text-rust font-semibold hover:text-gold transition-colors">All of {c.name}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Company">
          <h3 className="font-display font-bold uppercase tracking-wider text-sm text-cream/50 mb-4">Company</h3>
          <ul className="space-y-2.5 text-[15px]">
            <li><Link to="/services" data-testid="footer-services-hub" className="text-cream/80 hover:text-rust transition-colors">All Services</Link></li>
            <li><Link to="/service-areas" data-testid="footer-areas-hub" className="text-cream/80 hover:text-rust transition-colors">All Service Areas</Link></li>
            <li><Link to="/capabilities" data-testid="footer-capabilities" className="text-cream/80 hover:text-rust transition-colors">Capabilities & Certifications</Link></li>
            <li><Link to="/resources" data-testid="footer-resources" className="text-cream/80 hover:text-rust transition-colors">Guides & Resources</Link></li>
            <li><Link to="/about" data-testid="footer-about" className="text-cream/80 hover:text-rust transition-colors">About Us</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-cream/80 hover:text-rust transition-colors">Contact & Quick Quote</Link></li>
          </ul>
        </nav>
      </div>
      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-cream/50">
        <p>© {new Date().getFullYear()} {BUSINESS.name} · Established {BUSINESS.established} · Licensed & Insured</p>
        <p>Mobile welding repair — Fort Worth · Tarrant County · Parker County, TX</p>
      </div>
    </div>
  </footer>
);

export default Footer;
